import { ActionTree, GetterTree, Module, MutationTree } from "vuex"
import { RootState } from ".."
import { DateRange } from "../../types/moj-elektro"

export interface MojElektroFiltersState {
    dateRange: DateRange | null
    selectedDeviceId: number | null
    vt: number | null
    mt: number | null
    et: number | null
}

const state: MojElektroFiltersState = {
    dateRange: null,
    selectedDeviceId: null,
    vt: null,
    mt: null,
    et: null,
}

const mutations: MutationTree<MojElektroFiltersState> = {
    setDateRange(state, dateRange: DateRange) {
        state.dateRange = dateRange
    },
    setSelectedDeviceId(state, deviceId: number) {
        if (isNaN(deviceId)) {
            state.selectedDeviceId = null
        }

        state.selectedDeviceId = deviceId
    },
    setVt(state, vt: number) {
        if (typeof vt !== "number" || isNaN(vt) || vt < 0) {
            return (state.vt = null)
        }

        state.vt = vt
    },
    setMt(state, mt: number) {
        if (typeof mt !== "number" || isNaN(mt) || mt < 0) {
            return (state.mt = null)
        }

        state.mt = mt
    },
    setEt(state, et: number) {
        if (typeof et !== "number" || isNaN(et) || et < 0) {
            return (state.et = null)
        }

        state.et = et
    },
}

const actions: ActionTree<MojElektroFiltersState, RootState> = {
    setDateRange({ commit, dispatch }, dateRange: DateRange) {
        commit("setDateRange", dateRange)
        dispatch("mojElektroCalculationsModule/updateMonthsArray", dateRange, { root: true })
    },
    setSelectedDeviceId({ commit }, deviceId: number) {
        commit("setSelectedDeviceId", deviceId)
    },
    setVt({ commit }, vt: number) {
        commit("setVt", vt)
    },
    setMt({ commit }, mt: number) {
        commit("setMt", mt)
    },
    setEt({ commit }, et: number) {
        commit("setEt", et)
    },
}

const getters: GetterTree<MojElektroFiltersState, RootState> = {
    dateRange: (state) => state.dateRange,
    getSelectedDeviceId: (state) => state.selectedDeviceId,
    getVt: (state) => state.vt,
    getMt: (state) => state.mt,
    getEt: (state) => state.et,
}

const mojElektroFiltersModule: Module<MojElektroFiltersState, RootState> = {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}

export default mojElektroFiltersModule
